import { useState, useCallback } from 'react';

interface PromptOptions {
  title: string;
  message?: string;
  placeholder?: string;
  defaultValue?: string;
  submitLabel?: string;
  cancelLabel?: string;
}

interface PromptState extends PromptOptions {
  isOpen: boolean;
  onSubmit: (value: string) => void;
}

export const usePrompt = () => {
  const [promptState, setPromptState] = useState<PromptState>({
    isOpen: false,
    title: '',
    message: '',
    placeholder: '',
    defaultValue: '',
    submitLabel: 'OK',
    cancelLabel: 'Cancel',
    onSubmit: () => {}
  });

  const prompt = useCallback((options: PromptOptions): Promise<string | null> => {
    return new Promise((resolve) => {
      setPromptState({
        ...options,
        isOpen: true,
        onSubmit: (value: string) => {
          resolve(value);
          setPromptState(prev => ({ ...prev, isOpen: false }));
        }
      });

      const originalClose = () => {
        resolve(null);
        setPromptState(prev => ({ ...prev, isOpen: false }));
      };
    });
  }, []);

  const closePrompt = useCallback(() => {
    setPromptState(prev => ({ ...prev, isOpen: false }));
  }, []);

  return {
    prompt,
    promptState,
    closePrompt
  };
};
